export default __webpack_public_path__ + "static/media/metamask.c901ad35.svg";